var map = {
	"./autocomplete.md": [
		6638,
		6638
	],
	"./fizzbuzz.md": [
		8185,
		8185
	],
	"./palindrome.md": [
		4594,
		4594
	],
	"./rotategrid.md": [
		2291,
		2684
	],
	"./tinyurl.md": [
		5133,
		5133
	],
	"./twitter.md": [
		7554,
		7554
	],
	"./twosum.md": [
		7631,
		7631
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5009;
module.exports = webpackAsyncContext;